import { render } from "./ProfileAboutSection.vue?vue&type=template&id=b7ced4b6"
const script = {}

import exportComponent from "/tmp/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__